var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToggleMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20729 8.69822C3.20729 9.08175 3.26665 9.45615 3.37623 9.80316C1.62294 9.1959 0.298833 7.58415 0.161857 5.69844C0.024881 3.69403 1.18005 1.82202 3.04749 1.03669C3.53147 0.835793 3.77803 0.981901 3.88304 1.08692C3.98349 1.18737 4.12503 1.42936 3.92413 1.89051C3.71867 2.36536 3.61822 2.8676 3.61822 3.38811C3.62279 4.31955 3.98806 5.1825 4.58162 5.84455C3.74607 6.51117 3.20729 7.54306 3.20729 8.69822Z",
    fill: "#105DAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.7822 8.11364C7.87816 9.34186 6.44448 10.0633 4.91491 10.0633C4.84186 10.0633 4.7688 10.0587 4.69575 10.0541C4.23916 10.0359 3.79627 9.94912 3.37621 9.80301C3.26663 9.45601 3.20728 9.08161 3.20728 8.69807C3.20728 7.54291 3.74605 6.51102 4.5816 5.84441C5.25279 6.59777 6.21618 7.08632 7.28003 7.13198C7.56768 7.14568 7.85533 7.12285 8.13841 7.07262C8.64979 6.98131 8.85526 7.17307 8.92831 7.29635C9.00593 7.41963 9.08812 7.68902 8.7822 8.11364Z",
    fill: "#105DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleMoon);
export default __webpack_public_path__ + "static/media/toggle-moon.10012cf7db5d5a4a7163eba580b8c99f.svg";
export { ForwardRef as ReactComponent };